import { Box, styled } from "@material-ui/core";

export const FilterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    width: "100%",
    "& > *": {
      width: "100%"
    }
  },
  "& .product-base-filter": {
    minWidth: "300px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%"
    }
  }
}));
